import {OdpSegmentCache} from '../../core/utils/odp';

var _ = require('optimizely-client-fn');

var AsyncRequest = require('core/utils/async_request');
var Cookie = require('core/utils/cookie');
var createError = require('core/utils/custom_error').create;
var JSONEnv = require('core/lib/json');
var Logger = require('core/utils/logger');
var performanceEnv = require('core/env/performance');
var actionTypes = require('core/constants/action_types');
var Flux = require('core/flux');
var Poll = require('core/utils/poll');
var PromiseEnv = require('core/lib/promise');
var WindowEnv = require('core/env/window');
var XHR = require('core/utils/xhr');
var Query = require('core/utils/query');
var Visitor = require('core/visitor');
var enums = require('core/constants/enums');
var OdpUtils = require('core/utils/odp');
var DateEnv = require('core/env/date');


var VENDOR = 'odp';
var VUID_COOKIE_NAME = 'vuid';
var GLOBAL_OBJECT_NAME = 'zaius';
var PASSTHROUGH_USER = 'web_user_id';
var CALL_COUNTER = 0;
var HOST_MAP = {
  'zaius-staging': '//v3-staging.api.zaius.com',
  'zaius-us-endpoint': '//api.zaius.com/v3',
  'zaius-eu-endpoint': '//api.eu1.odp.optimizely.com/v3',
  'zaius-ap-endpoint': '//api.au1.odp.optimizely.com/v3'
};

var USER_ID_TYPE = {
  VUID: 'vuid',
  OEU_ID: 'oeu_id'  // Optimizely End User Id
};

var USER_ID_CONFIDENCE_LEVEL = {
  LOW: 'low',
  HIGH: 'high'
};

var ODPError = createError('ODPError');

function getVuid() {
  /* Try to get it from cookie */
  var vuid = Cookie.get(VUID_COOKIE_NAME);
  if (vuid) {
    vuid = vuid.split('|')[0].split('-').join('');
    return vuid;
  }

  /* Try from global object */
  var odp = WindowEnv.getGlobal(GLOBAL_OBJECT_NAME);
  if (odp && odp.hasOwnProperty('VUID')) {
    vuid = odp.VUID;
    if (vuid)
      return vuid.split('-').join('');
  }
}

function getUserId(user_id_type, confidence_level) {
  let identifier;
  let user_id;

  if (user_id_type === USER_ID_TYPE.VUID) {
    var vuid = getVuid();
    if (!vuid)
      return null;
    identifier = 'vuid';
    user_id = vuid;
  } else if (user_id_type === USER_ID_TYPE.OEU_ID) {
    user_id = Visitor.getCurrentId();
    identifier = `${confidence_level}_web_user_id`;
  }

  return {
    identifier,
    user_id
  };
}


function getAudiences(dataObject) {
  var audiences = [];
  try {
      _.forEach((dataObject.errors, function (error) {
        Logger.warn(`ODP ${error.message} - code: ${error.extensions.code} - classification: ${error.extensions.classification}`);
      }));

      audiences = _(dataObject.data.customer.audiences.edges)
        .filter((edge) => edge.node && edge.node.state === 'qualified')
        .map((edge) => edge.node && edge.node.name)
        .value();
  } catch (e) {
    if (e instanceof TypeError) {
      Logger.warn('ODP Data response object doesn\'t have the expected format');
    } else {
      throw e;
    }
  }

  // We don't need to split the comming ODP segments
  // beacuse this split is only for audience creation
  return {
    audiences: audiences,   // For Prebuilt segments matching
    custom: audiences       // For Custom segments matching
  };
}


function fetchOdpData(host, publicKey, identifier, user_id, neededSegments) {
  var url = host + '/graphql';
  (__PROFILE__ || __RUM_VERBOSE__) && performanceEnv.time('odpCall');
  return XHR.request({
    url: url,
    method: 'POST',
    async: true,
    contentType: 'application/json',
    headers: {
      'x-api-key': publicKey
    },
    data: {
      query: 'query MyQuery {\n  customer(' + identifier + ': "' + user_id + '") {\n    vuid\n    audiences (subset: ' + JSONEnv.stringify(neededSegments) + ') {\n      edges {\n        node {\n          is_ready\n          name\n          state\n        }\n      }\n    }\n  }\n}',
      variables: {}
    }
  }).then(function (res) {
    (__PROFILE__ || __RUM_VERBOSE__) && performanceEnv.timeEnd ('odpCall');
    var data;
    if (res.status > 399) {
      // Intentionally swallow response body since it might expose implementation details (AUD-1605)
      throw new ODPError(res.status + ': ' + res.statusText);
    }

    try {
      data = JSONEnv.parse(res.response);
    } catch (e) {
      throw new ODPError('Error parsing response: ' + e.toString());
    }

    if (!data) {
      throw new ODPError('No data received');
    }

    return getAudiences(data);
  }, function (xhr) {
    (__PROFILE__ || __RUM_VERBOSE__) && performanceEnv.timeEnd ('odpCall');
    throw new ODPError(xhr.status + ': ' + xhr.statusText);
  });
}


function parseNeededSegments(audiencesData) {
  let segments = [];

  if(_.isArray(audiencesData)) {
    segments = segments.concat( _.flatten(_.map(audiencesData, parseNeededSegments)));
  }

  if (_.isObject(audiencesData)) {
    if( audiencesData.conditions && _.isArray(audiencesData.conditions) ) {
      segments = segments.concat(_.flatten(_.map(audiencesData.conditions, parseNeededSegments)));
    } else if(audiencesData.type && audiencesData.type === 'vendor.odp') {
      return [audiencesData.value];
    }
  }
  return segments;
}


function identifyUser(oeu_id, confidence_level) {
  // Send beacon with low and high only when confidence level is high
  // zaius.customer({
  //  low_web_user_id: oie_id,
  //  high_web_user_id: oie_id // Only if is high confidence
  // })

  var odp = WindowEnv.getGlobal(GLOBAL_OBJECT_NAME);
  if (odp) {
    var identifiers = {
      'low_web_user_id': oeu_id
    };
    if (confidence_level === USER_ID_CONFIDENCE_LEVEL.HIGH) {
      identifiers['high_web_user_id'] = oeu_id;
    }

    odp.onload(function(){
      odp.customer(identifiers, {});
    });
    return true;
  }
}

function getNeededSegments(integrationSettings, audiences) {
  let neededSegments = integrationSettings._neededSegments;
  if ( _.isNull(neededSegments) || _.isUndefined(neededSegments)) {
    neededSegments = parseNeededSegments(audiences);

    Flux.dispatch(actionTypes.SET_INTEGRATION_SETTINGS, {
      'id': 'odp',
      '_neededSegments': neededSegments
    });
  }

  return neededSegments;
}


function setUpFullOdpIntegration(integrationSettings){
  const user_id_type = integrationSettings.user_id || USER_ID_TYPE.OEU_ID;
  const confidence_level = integrationSettings.confidence_level || USER_ID_CONFIDENCE_LEVEL.LOW;

  Poll.pollFor(_.partial(identifyUser, Visitor.getCurrentId(), confidence_level), 50, 20);

  return Poll.pollFor(_.partial(getUserId, user_id_type, confidence_level), 50, 20);
}


function setUpPassthroughIntegration(integrationSettings){
  const identifierType = integrationSettings.identifier_type || enums.VisitorIdLocatorType.COOKIE;
  const identifierName = integrationSettings.identifier_name;
  let userId;

  switch(identifierType) {
    case enums.VisitorIdLocatorType.COOKIE:
      userId = Cookie.get(identifierName);
      break;
    case enums.VisitorIdLocatorType.JS_VARIABLE:
      userId = WindowEnv.getGlobalByPath(identifierName);
      break;
    case enums.VisitorIdLocatorType.LOCALSTORAGE:
      try {
        var localStorage = WindowEnv.getGlobal('localStorage');
        userId = localStorage.getItem(identifierName);
      } catch(e) {
        Logger.warn('ODP Cant access local storage');
      }
      break;
    case enums.VisitorIdLocatorType.QUERY:
      userId = Query.getQueryParamValue(identifierName);
      break;
    default:
      Logger.warn('ODP Passthrough Invalid identifier type: "' + identifierType + '".');
  }

  if(_.isEmpty(userId)){
    Logger.warn(
      'ODP Passthrough, Identifier not found, does not exist or is empty at visitor bucketing time. ' +
      `Type: '${identifierType}', Name: '${identifierName}'.`
    );
    userId = undefined;
  } else if (!_.isString(userId) && !_.isNumber(userId)) {
    Logger.warn('ODP Passthrough Invalid user id or is neither string or number.');
    userId = undefined;
  }

  return PromiseEnv.resolve({
    identifier: PASSTHROUGH_USER,
    user_id: userId
  });
}


var pluginAudienceOdp:AudiencePluginConfig = {
  provider: {
    isAsync: true,
    isLazy: true,
    isSticky: __ODP_AUDIENCE_STICKY__,
    isTransient: __ODP_AUDIENCE_TRANSIENT__,
    getter: [
      'stores/integration_settings',
      'stores/audience_data',
      'stores/visitor_bucketing',
      /**
       * @returns {Object}
       */
      function (IntegrationSettingsStore, AudienceDataStore, VisitorStore) {
        const integrationSettings = IntegrationSettingsStore.get(VENDOR) || {};

        if (_.isEmpty(integrationSettings))
          return PromiseEnv.reject(new ODPError('ODP integration settings data missing.'));

        const neededSegments = getNeededSegments(integrationSettings, AudienceDataStore.getAll());

        if (_.isEmpty(neededSegments))
          return PromiseEnv.resolve({});

        const publicKey = integrationSettings.public_key;
        const host = HOST_MAP[integrationSettings.zaius_host] || __ODP_DEFAULT_HOST__;
        const isPassthrough = integrationSettings.is_passthrough || 'off';

        if (_.isUndefined(publicKey))
          return PromiseEnv.reject(new ODPError('ODP public_key missing from integration settings'));

        let source = `${VENDOR}_${CALL_COUNTER}`;

        return AsyncRequest.makeAsyncRequest(source, function() {
          let setUpPromise = isPassthrough === 'on' ?
            setUpPassthroughIntegration(integrationSettings) :
            setUpFullOdpIntegration(integrationSettings);

          setUpPromise.then(function({identifier, user_id}){

            if(identifier === PASSTHROUGH_USER && _.isUndefined(user_id)){
              Logger.warn('ODP Passthrough.  Expect not fail if user_id cant be resolved.');
              return PromiseEnv.resolve({
                audiences: [],
                custom: []
              });
            }

            let odpAudienceTTL: number = __ODP_AUDIENCE_TTL__;
            let hashValueForCacheSegments = OdpUtils.getHashForOdpSegments(neededSegments);
            let cacheData: OdpSegmentCache = VisitorStore.getOdpSegments();
            let currentTime: number = DateEnv.now();
            let isValidCache: boolean = (cacheData?.timestamp && (cacheData.timestamp + odpAudienceTTL >= currentTime));
            let isValidHash: boolean = (cacheData?.timestamp && (cacheData.segmentHash === hashValueForCacheSegments));
            let cacheHit: boolean = (isValidCache && isValidHash);
            if (!cacheHit) {
              Logger.log('ODP / cache miss, calling odp');
              return fetchOdpData(host, publicKey, identifier, user_id, neededSegments)
                  .then((odpData) => {
                    let hashValue = OdpUtils.getHashForOdpSegments(odpData.audiences);
                    let timeNow = DateEnv.now();
                    const segmentCache: OdpSegmentCache = {
                      segment: odpData,
                      segmentHash: hashValue,
                      timestamp: timeNow,
                    };
                    Flux.dispatch(actionTypes.SET_ODP_SEGMENTS, segmentCache);
                    Visitor.persistOdpSegments(segmentCache);
                    return odpData;
                  }).catch((error) => {throw error;});
            } else {
              Logger.log('ODP / cache hit with data', cacheData);
              return cacheData.segment;
            }
          }).then(
            function(data){ CALL_COUNTER = CALL_COUNTER + 1; return data;},
            function(error){ CALL_COUNTER = CALL_COUNTER + 1; throw error;}
          ).then(
            _.partial(AsyncRequest.resolveRequest, source),
            _.partial(AsyncRequest.rejectRequest, source)
          );
        });
      },
    ],
  },

  matcher: require('core/plugins/matchers/key_value'),
  vendor: VENDOR,
};

module.exports = function (PluginManager) {
  PluginManager.registerAudiencePlugin(pluginAudienceOdp);
};

if (__TEST__) {
  module.exports = pluginAudienceOdp;
}
